import React from 'react';

export default function ChevronRight({ iconClass }: { iconClass?: string }) {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={iconClass}
    >
      <path d="m490.4 320-17 17-200 200-17 17-33.9-33.9 17-17 183-183-183-183-17-17 33.9-33.9 17 17 200 200 17 17z" />
    </svg>
  )
}
